export interface IBreadCrumb {
    label: string;
    routerLink: string;
}
